export default {
      id: "calendar-lite-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#calendar-lite",
      toString: function () {
        return this.url;
      }
    }